import { render, staticRenderFns } from "./treeForm.vue?vue&type=template&id=81263bfc&scoped=true&"
import script from "./treeForm.vue?vue&type=script&lang=js&"
export * from "./treeForm.vue?vue&type=script&lang=js&"
import style0 from "./treeForm.vue?vue&type=style&index=0&id=81263bfc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81263bfc",
  null
  
)

export default component.exports